<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="os-tabs-w">
               <div class="os-tabs-controls os-tabs-complex">
                 <ul class="nav nav-tabs" id="myTab" role="tablist">
                   <li class="nav-item">
                     <a class="nav-link active" id="multi1v1-tab" data-toggle="tab" href="#multi1v1" role="tab" aria-controls="multi1v1" aria-selected="true">Multi 1v1</a>
                   </li>
                   <li class="nav-item">
                     <a class="nav-link" id="retakes-tab" data-toggle="tab" href="#retakes" role="tab" aria-controls="retakes" aria-selected="false">Retakes</a>
                   </li>
                   <li class="nav-item">
                     <a class="nav-link" id="pug-tab" data-toggle="tab" href="#pug" role="tab" aria-controls="pug" aria-selected="false">PUG</a>
                   </li>
                 </ul>
               </div>
             </div>
             <div class="tab-content" id="myTabContent">
               <div class="tab-pane fade show active" id="multi1v1" role="tabpanel" aria-labelledby="multi1v1-tab">
                 <div class="alert alert-danger" role="alert" v-if="!this.$root.isAuthenticated">
                   Register/Login to see your current standings.
                 </div>
                 <div class="row pt-4">
                   <div class="col-sm-12">
                     <div class="element-wrapper">
                       <div class="element-box">
                         <div class="table-responsive">
                           <table class="table table-lightborder">
                             <thead class="thead">
                               <tr>
                                 <th>#</th>
                                 <th>ID</th>
                                 <th>Username</th>
                                 <th>Wins</th>
                                 <th>Loses</th>
                                 <th>Rifle Rating</th>
                                 <th>Pistol Rating</th>
                                 <th>AWP Rating</th>
                                 <th><b>Overall Rating</b></th>
                               </tr>
                             </thead>
                             <tbody id="serverListTbl">
                               <tr v-if="this.$root.isAuthenticated">
                                 <td>{{ this.multi1v1_profile.rank }}</td>
                                 <td>{{ this.multi1v1_profile.auth }}</td>
                                 <td>{{ this.multi1v1_profile.name }}</td>
                                 <td>{{ this.multi1v1_profile.wins }}</td>
                                 <td>{{ this.multi1v1_profile.losses }}</td>
                                 <td>{{ this.multi1v1_profile.rifleRating }}</td>
                                 <td>{{ this.multi1v1_profile.pistolRating }}</td>
                                 <td>{{ this.multi1v1_profile.awpRating }}</td>
                                 <td><b>{{ this.multi1v1_profile.rating }}</b></td>
                               </tr>
                               <tr v-for="(player, index) in multi1v1">
                                 <td>{{ index + 1 }}</td>
                                 <td>{{ player.auth }}</td>
                                 <td>{{ player.name }}</td>
                                 <td>{{ player.wins }}</td>
                                 <td>{{ player.losses }}</td>
                                 <td>{{ player.rifleRating }}</td>
                                 <td>{{ player.pistolRating }}</td>
                                 <td>{{ player.awpRating }}</td>
                                 <td><b>{{ player.rating }}</b></td>
                               </tr>
                             </tbody>
                           </table>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="tab-pane fade" id="retakes" role="tabpanel" aria-labelledby="retakes-tab">
                 <div class="row pt-4">
                   <div class="col-sm-12">
                     <div class="element-wrapper">
                       <div class="element-box">
                         <div class="table-responsive">
                           <table class="table table-lightborder">
                             <thead class="thead">
                               <tr>
                                 <th>#</th>
                                 <th>ID</th>
                                 <th>Username</th>
                                 <th>Country</th>
                                 <th>Kills</th>
                                 <th>Assists</th>
                                 <th>Death</th>
                                 <th>Wins</th>
                                 <th>Losses</th>
                                 <th><b>Rating</b></th>
                               </tr>
                             </thead>
                             <tbody id="serverListTbl">
                               <tr v-for="(player, index) in retakes">
                                 <td>{{ index + 1 }}</td>
                                 <td>{{ player.id }}</td>
                                 <td><a target="_blank" v-bind:href="'https://steamcommunity.com/profiles/' + player.steamid64">{{ player.username }}</a></td>
                                 <td>{{ player.country }}</td>
                                 <td>{{ player.stats['retakes'].kills }}</td>
                                 <td>{{ player.stats['retakes'].assists }}</td>
                                 <td>{{ player.stats['retakes'].deaths }}</td>
                                 <td>{{ player.stats['retakes'].wins }}</td>
                                 <td>{{ player.stats['retakes'].losses }}</td>
                                 <td><b>{{ player.stats['retakes'].rating.toFixed(0) }}</b></td>
                               </tr>
                             </tbody>
                           </table>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="tab-pane fade" id="pug" role="tabpanel" aria-labelledby="pug-tab">
                 <div class="row pt-4">
                   <div class="col-sm-12">
                     <div class="element-wrapper">
                       <div class="element-box">
                         <div class="table-responsive">
                           <table class="table table-lightborder">
                             <thead class="thead">
                               <tr>
                                 <th>#</th>
                                 <th>ID</th>
                                 <th>Username</th>
                                 <th>Country</th>
                                 <th>Kills</th>
                                 <th>Assists</th>
                                 <th>Death</th>
                                 <th>Wins</th>
                                 <th>Losses</th>
                                 <th><b>Rating</b></th>
                               </tr>
                             </thead>
                             <tbody id="serverListTbl">
                               <tr v-for="(player, index) in pug">
                                 <td>{{ index + 1 }}</td>
                                 <td>{{ player.id }}</td>
                                 <td><a target="_blank" v-bind:href="'https://steamcommunity.com/profiles/' + player.steamid64">{{ player.username }}</a></td>
                                 <td>{{ player.country }}</td>
                                 <td>{{ player.stats['pug'].kills }}</td>
                                 <td>{{ player.stats['pug'].assists }}</td>
                                 <td>{{ player.stats['pug'].deaths }}</td>
                                 <td>{{ player.stats['pug'].wins }}</td>
                                 <td>{{ player.stats['pug'].losses }}</td>
                                 <td><b>{{ player.stats['pug'].rating.toFixed(0) }}</b></td>
                               </tr>
                             </tbody>
                           </table>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="tab-pane fade" id="surf" role="tabpanel" aria-labelledby="surf-tab">.12312333243..</div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from './partials/Navbar.vue';
import Sidebar from './partials/Sidebar.vue';
import Alert from './partials/Alert';
import DarkColor from './partials/DarkColor';
import RightSidebar from './partials/RightSidebar';
import Invitation from './partials/Invitation';

export default {
  name: 'Statistics',
  metaInfo: {
    title: 'statistics',
    titleTemplate: 'zero1 by Dreamstart | %s',
    meta: [
      { property: 'og:title', content: 'zero1 by Dreamstart | statistics' },
      { property: 'og:site_name', content: 'zero1' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://zero1.gg/servers'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'zero1 by Dreamstart | statistics' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to zero1!',
      servers: [],
      multi1v1: [],
      multi1v1_profile: {},
      retakes: [],
      pug: []
    }
  },
  computed: {
    //
  },
  methods: {
    getServers() {
      this.axios.get(`${this.API_URL}/servers`).then((res) => {
        res.data.find((s, v) => {
          s.steam_url = `steam://connect/${s.full_address}`;
          this.servers.push(s);
        });
      });
    },
    getMulti1v1Player() {
      if (this.$root.isAuthenticated) {
        this.axios.get(`${this.API_URL}/apollo/stats/multi1v1/${this.$root.userProfile.id}`).then((res) => {
          this.multi1v1_profile = res.data;
          this.getMulti1v1Stats();
        });
      } else {
        this.getMulti1v1Stats();
      }
    },
    getMulti1v1Stats() {
      this.axios.get(`${this.API_URL}/apollo/stats/multi1v1/events`).then((res) => {
        res.data.find((p, v) => {
          this.multi1v1.push(p);
        })
      });
    },
    getRetakesStats() {
      this.axios.get(`https://api.zero1.gg/api/v3/events/season1-retakes/stats`).then((res) => {
        this.retakes = res.data;
      });
    },
    getPUGStats() {
      this.axios.get(`https://api.zero1.gg/api/v3/events/season1-pug/stats`).then((res) => {
        this.pug = res.data;
      });
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    setTimeout(() => {
      this.getMulti1v1Player();
    }, 3500)
    this.getRetakesStats();
    this.getPUGStats();
  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
